import {
  PROJECTS_FAIL,
  PROJECTS_SUCCESS,
  PROJECTS_APPEND_SUCCESS,
  PROJECTS_REQUEST,
  PROJECT_CREATE_FAIL,
  PROJECT_CREATE_REQUEST,
  PROJECT_CREATE_SUCCESS,
  PROJECT_DELETE_SUCCESS,
  RENAME_PROJECT_SUCCESS,
  ALL_PROJECTS_SUCCESS,
  CARD_PROJECT_SUCCESS,
  CARD_PROJECT_FAIL,
  PROJECT_OPEN_REQUEST,
  PROJECT_OPEN_SUCCESS,
  PROJECT_OPEN_FAIL,
} from "../actions/types";

const initialState = {
  isLoading: false,
  error: null,
  projects: [],
  totalProjects: 0,
  allProjects: [],
  isMarkingProjectOpen: false,
  projectOpenError: null,
};

const projectsReducer = (state = initialState, action) => {
  switch (action.type) {
    case PROJECTS_REQUEST:
      return { ...state, isLoading: true };
    case PROJECTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        projects: action.payload.projects,
        totalProjects: action.payload.totalProjects,
      };
    case PROJECTS_APPEND_SUCCESS: {
      const incoming = action.payload.projects || [];
      const existingIds = new Set(state.projects.map((project) => project._id));
      const merged = [
        ...state.projects,
        ...incoming.filter((project) => !existingIds.has(project._id)),
      ];
      return {
        ...state,
        isLoading: false,
        projects: merged,
        totalProjects: action.payload.totalProjects,
      };
    }
    case ALL_PROJECTS_SUCCESS:
      return {
        ...state,
        allProjects: action.payload.allProjects,
      };
    case PROJECTS_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };
    case PROJECT_OPEN_REQUEST:
      return {
        ...state,
        isMarkingProjectOpen: true,
        projectOpenError: null,
      };
    case PROJECT_OPEN_SUCCESS:
      return {
        ...state,
        isMarkingProjectOpen: false,
        projects: state.projects.map((project) =>
          project?._id === action.payload.projectId
            ? { ...project, lastOpenedAt: action.payload.lastOpenedAt }
            : project,
        ),
      };
    case PROJECT_OPEN_FAIL:
      return {
        ...state,
        isMarkingProjectOpen: false,
        projectOpenError: action.payload.error,
      };
    case PROJECT_CREATE_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case PROJECT_CREATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        projects: [...state.projects, action.payload.project],
      };
    case PROJECT_CREATE_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };
    case CARD_PROJECT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        projects: [...state.projects, action.payload.cardProject],
      };
    case CARD_PROJECT_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };
    case PROJECT_DELETE_SUCCESS:
      const { projectId } = action.payload;
      return {
        ...state,
        projects: [
          ...state.projects.filter((project) => project._id !== projectId),
        ],
      };
    case RENAME_PROJECT_SUCCESS:
      const { updatedProject } = action?.payload;
      return {
        ...state,
        projects: state.projects.map((project) =>
          project?._id === updatedProject?._id ? updatedProject : project
        ),
      };
    default:
      return state;
  }
};

export default projectsReducer;
